import { render, staticRenderFns } from "./FideicomisoCesionarios.vue?vue&type=template&id=5d99022a&scoped=true"
import script from "./FideicomisoCesionarios.vue?vue&type=script&lang=js"
export * from "./FideicomisoCesionarios.vue?vue&type=script&lang=js"
import style0 from "./FideicomisoCesionarios.vue?vue&type=style&index=0&id=5d99022a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d99022a",
  null
  
)

export default component.exports